import { OrganizationHierarchyLevel } from './index';

export const getUniqueLeafHierarchyName = (
    hierarchy: OrganizationHierarchyLevel[],
): string | undefined => {
    const hasChild = new Set<string>();
    for (const level of hierarchy) {
        if (level.parentId) {
            hasChild.add(level.parentId);
        }
    }

    const leafNames = new Set<string>();
    for (const level of hierarchy) {
        if (!hasChild.has(level.id) && level.name?.trim().length) {
            leafNames.add(level.name);
        }
    }

    return leafNames.size === 1 ? [...leafNames][0] : undefined;
};
